<template>
  <div class="course-detail">
    <h1>{{ course.title }}</h1>
    <p>{{ course.description }}</p>
    <button @click="goBack">返回</button>
  </div>
</template>

<script>
export default {
  name: 'CourseDetail',
  data() {
    return {
      course: {},
    };
  },
  created() {
    const courseId = this.$route.params.id;
    this.course = this.getCourseById(courseId);
  },
  methods: {
    getCourseById(courseId) {
      const courses = [
      { id: 1, title: 'Vue 3 入门', description: '学习 Vue 3 的基础知识' },
        { id: 2, title: 'React 进阶', description: '深入理解 React 的高级特性' },
        { id: 3, title: 'Node.js 实战', description: '使用 Node.js 构建后端服务' },
        { id: 4, title: 'TypeScript 精讲', description: '掌握 TypeScript 的核心概念' },
        { id: 5, title: 'Vue 3 入门', description: '学习 Vue 3 的基础知识' },
        { id: 6, title: 'React 进阶', description: '深入理解 React 的高级特性' },
        { id: 7, title: 'Node.js 实战', description: '使用 Node.js 构建后端服务' },
        { id: 8, title: 'TypeScript 精讲', description: '掌握 TypeScript 的核心概念' },
        { id: 9, title: 'Vue 3 入门', description: '学习 Vue 3 的基础知识' },
        { id: 10, title: 'React 进阶', description: '深入理解 React 的高级特性' },
        { id: 11, title: 'Node.js 实战', description: '使用 Node.js 构建后端服务' },
        { id: 12, title: 'TypeScript 精讲', description: '掌握 TypeScript 的核心概念' },
        { id: 13, title: 'Vue 3 入门', description: '学习 Vue 3 的基础知识' },
        { id: 14, title: 'React 进阶', description: '深入理解 React 的高级特性' },
        { id: 15, title: 'Node.js 实战', description: '使用 Node.js 构建后端服务' },
        { id: 16, title: 'TypeScript 精讲', description: '掌握 TypeScript 的核心概念' },
      ];
      return courses.find((course) => course.id === Number(courseId));
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.course-detail {
  padding: 20px;
}

h1 {
  margin: 0 0 10px;
}

button {
  margin-top: 10px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>